import { Event } from "@gaming/srvg-classes-core";
import { Chunk } from "../Data/Chunk";


export class ChunkPickEvent extends Event {
    chunk: Chunk;

    constructor( chunk: Chunk ) {
        super( { eventType: ChunkPickEvent.getEventType() } );

        this.chunk = chunk;
    }

    static getEventType() {
        return 'chunkPick';
    }

    destroy() {
        this.chunk = null;
        super.destroy();
    }
}